<div class="main-section">
  <p class="ms-heading">{{ permissionName | translate}}</p>
  <div class="no-access-section">
    <img class="no-access-img" src="assets/images/no-permission.svg" alt="no-permission" />
    <div class="no-access-title">
      {{ "YouDontHaveThePermissionToAccessThe" | translate }}
      {{ permissionName  | translate}}.
    </div>
    <div class="no-access-subtitle">
      {{ "PleaseContactTheOwner" | translate }}
      {{ "IfYouWantAccessToThisSection" | translate }}
    </div>
    <!-- <div class="hzvt-item-center">
      <button class="act-btn-dark">{{ "ContactNow" | translate }}</button>
    </div> -->
  </div>
</div>
